import { Drawer as BaseDrawer } from '@base-ui/react/drawer';
import type { DrawerPopupProps } from '@base-ui/react/drawer';

export const Root = BaseDrawer.Root;
export const Trigger = BaseDrawer.Trigger;
export const Title = BaseDrawer.Title;
export const Description = BaseDrawer.Description;
export const Close = BaseDrawer.Close;

type ContentProps = Omit<DrawerPopupProps, 'className' | 'ref'> & {
  /** Styles the content below the handle bar. */
  className?: string;
};

/** The bottom sheet with its portal, backdrop and handle bar. */
export const Content = ({ className, children, ...props }: ContentProps) => (
  <BaseDrawer.Portal>
    <BaseDrawer.Backdrop className="fixed inset-0 z-popover bg-shadow-dark transition-opacity duration-300 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0" />
    <BaseDrawer.Viewport className="fixed inset-0 z-popover flex items-end justify-center">
      <BaseDrawer.Popup
        className="relative flex w-full flex-col items-center rounded-t-lg bg-base-light p-[15px_15px_20px] outline-none transition-transform duration-300 [transform:translateY(var(--drawer-swipe-movement-y))] data-[ending-style]:[transform:translateY(100%)] data-[starting-style]:[transform:translateY(100%)] data-[swiping]:duration-0"
        {...props}
      >
        <div className="mb-5 h-[3px] w-[100px] bg-neutral-lighter" />
        <BaseDrawer.Content className={className}>
          {children}
        </BaseDrawer.Content>
      </BaseDrawer.Popup>
    </BaseDrawer.Viewport>
  </BaseDrawer.Portal>
);
